const menuToggler = document.querySelector('#hamburger-button');
const menuWrapper = document.querySelector('#nav-wrapper');
const menu = document.querySelector('#mega-menu');
const topBar = document.querySelector('#masthead');
const hamburgerContainer = document.querySelector('#hamburger-button');
let currentMenuItem;

const Mainmenu = {
	registerEvents: () => {
		menuToggler.addEventListener('click', Mainmenu.toggleMainMenu);
		document.addEventListener('click', Mainmenu.closeOpenSubmenu);
	},

	toggleMainMenu: () => {
		if (hamburgerContainer.classList.contains('open')) {
			hamburgerContainer.classList.remove('open');
			menuWrapper.classList.remove('active');
			topBar.classList.remove('active');
			document.querySelector('html > body').classList.remove('menuactive');
		} else {
			hamburgerContainer.classList.add('open');
			menuWrapper.classList.add('active');
			topBar.classList.add('active');
			document.querySelector('html > body').classList.add('menuactive');
		}
		Mainmenu.ariaUpdate();
	},

	ariaUpdate: () => {
		let menuTogglerAria = menuToggler.getAttribute('aria-expanded');
		let menuAria = menuWrapper.getAttribute('aria-hidden');

		menuTogglerAria = menuTogglerAria === 'true' ? 'false' : 'true';
		menuAria = menuAria === 'true' ? 'false' : 'true';

		menuToggler.setAttribute('aria-expanded', menuTogglerAria);
		menuWrapper.setAttribute('aria-hidden', menuAria);
	},

	menuAccordion: () => {
		let accordionHeading = document.querySelectorAll('ul.main-menu > li.menu-item-has-children > a');

		accordionHeading.forEach((item, key) => {
			item.addEventListener('click', (e) => {
				e.preventDefault();
				Mainmenu.toggleSubmenu(item);
			});
			item.addEventListener('keypress', (e) => {
				Mainmenu.toggleSubmenu(item);
			});
		});
	},

	toggleSubmenu: (item) => {
		let subMenu = item.nextElementSibling;

		item.classList.contains('active') ? item.classList.remove('active') : item.classList.add('active');

		if (subMenu.classList.contains('active')) {
			subMenu.classList.remove('active');
			subMenu.setAttribute('aria-expanded', false);
			subMenu.setAttribute('aria-hidden', true);
		} else {
			subMenu.classList.add('active');
			subMenu.setAttribute('aria-expanded', true);
			subMenu.setAttribute('aria-hidden', false);
		}

		if (currentMenuItem && item !== currentMenuItem) {
			Mainmenu.toggleSubmenu(currentMenuItem);
		}

		if (item.classList.contains('active')) {
			currentMenuItem = item;
		} else {
			currentMenuItem = false;
		}

		if (subMenu.style.maxHeight) {
			subMenu.style.maxHeight = null;
		} else {
			subMenu.style.maxHeight = subMenu.scrollHeight + 'px';
		}
	},

	closeOpenSubmenu: (e) => {
		if (currentMenuItem && !e.target.closest('#' + menu.id)) {
			Mainmenu.toggleSubmenu(currentMenuItem);
		}
	},

	init: () => {
		Mainmenu.registerEvents();
		Mainmenu.menuAccordion();

		document.addEventListener('keyup', (event) => {
			if (event.keyCode === 27) {
				// we're in a submenu item
				if (null !== event.target.closest('ul[aria-hidden="false"]')) {
					currentMenuItem.focus();
					Mainmenu.toggleSubmenu(currentMenuItem);
				}

				if (document.querySelector('body').classList.contains('menuactive')) menuToggler.click();
			}
		});
	},
};

export default Mainmenu;
